/*
 * @Author: hfxie
 * @Date: 2021-01-01 14:52:54
 * @LastEditors: haifeng_xie haifeng_xie@kingdee.com
 * @LastEditTime: 2023-09-06 17:20:27
 * @Description: file content
 */
/**
 *
 * 全局组件
 */

import { Icon, Button, Select, Option, Message, MessageBox, Input, Popover, Tooltip, Empty, Loading } from "element-ui";

const obj = {
  Icon,
  Button,
  Select,
  Option,
  Message,
  MessageBox,
  "el-input": Input,
  "el-popover": Popover,
  "el-tooltip": Tooltip,
  "el-empty": Empty,
};

const components = {};
components.install = function(Vue, options) {
  for (const name in obj) {
    if (name && obj[name]) {
      Vue.component(name, obj[name]);
      if (["Message", "Modal"].includes(name)) {
        Vue.prototype[`$${name}`] = obj[name];
      }
    }
  }
  Vue.prototype.$MessageBox = MessageBox;
  Vue.use(Loading.directive);
};

export default components;
